import React from "react";
import { LinkOutlined, CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useCopyShortUrl } from "./useCopyShortUrl";

const StyledButton = styled.button<{ $state: "idle" | "loading" | "done"; $variant: "default" | "action" }>`
	-webkit-tap-highlight-color: transparent;
	touch-action: manipulation;

	background: ${(props) =>
		props.$variant === "action"
			? "transparent"
			: props.$state === "done"
				? "#f6ffed"
				: props.$state === "loading"
					? "#f5f5f5"
					: "#f0f5ff"};
	border: ${(props) =>
		props.$variant === "action"
			? "none"
			: `1px solid ${props.$state === "done" ? "#b7eb8f" : props.$state === "loading" ? "#d9d9d9" : "#adc6ff"}`};
	cursor: ${(props) => (props.$state === "loading" ? "wait" : "pointer")};
	padding: 6px 12px;
	border-radius: 50px;
	white-space: nowrap;
	color: ${(props) =>
		props.$variant === "action"
			? props.$state === "done"
				? "#16a34a"
				: props.$state === "loading"
					? "#999"
					: "#444"
			: props.$state === "done"
				? "#52c41a"
				: props.$state === "loading"
					? "#999"
					: "#4460EF"};
	font-size: ${(p) => (p.$variant === "action" ? "14px" : "13px")};
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	transition: all 0.2s;
	white-space: nowrap;
	&:hover {
		background: ${(props) =>
			props.$variant === "action"
				? "#fff"
				: props.$state === "done"
					? "#f6ffed"
					: props.$state === "loading"
						? "#f5f5f5"
						: "#e6f0ff"};
		border-color: ${(props) =>
			props.$variant === "action"
				? "transparent"
				: props.$state === "done"
					? "#b7eb8f"
					: props.$state === "loading"
						? "#d9d9d9"
						: "#4460EF"};
		box-shadow: ${(props) => (props.$variant === "action" ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none")};
	}

	&:active {
		background: #efefef;

		svg {
			color: #f72586;
			transition: color 0.2s ease;
		}
	}
`;

interface CopyShortUrlButtonProps {
	targetUrl?: string;
	variant?: "default" | "action";
}

export const CopyShortUrlButton: React.FC<CopyShortUrlButtonProps> = ({ targetUrl, variant = "default" }) => {
	const { state, label, copy } = useCopyShortUrl(targetUrl);

	const icon =
		state === "loading" ? (
			<LoadingOutlined spin />
		) : state === "done" ? (
			<CheckOutlined />
		) : variant === "action" ? (
			<LinkOutlined style={{ fontSize: 18 }} />
		) : (
			<LinkOutlined />
		);

	return (
		<StyledButton onClick={copy} $state={state} $variant={variant}>
			{icon} {label}
		</StyledButton>
	);
};
